import {
  apiWatchlist,
  apiCheckAssetInWatchlist,
  apiUpdateWatchlist,
} from "../../api/watchlist";
import * as constant from './constant'
export const actions = {
  async findWatchlist({ commit, state }, subject_type) {
    try {
      state.loadingWatchlist = true
      const rs = await apiWatchlist(subject_type, 'list');
      if (rs && rs.status == 200) {
        let data = rs.data
        if (data) {
          switch (subject_type) {
            case 'stock':
              await commit(constant.WATCHLIST_STOCK, data.data)
              break;
            case 'fund':
              await commit(constant.WATCHLIST_FUND, data.data)
              break;
            case 'gold':
              await commit(constant.WATCHLIST_GOLD, data.data)
              break;
            default:
              break;
          }
        }
      }
    } catch (error) {
      console.error(error)
    } finally {
      state.loadingWatchlist = false
    }
  },
  async checkAssetInWatchlist({commit, dispatch}, {subjectType, id}) {
    let exist = false
    try {
      const rs = await apiCheckAssetInWatchlist(subjectType, id)
      if (rs && rs.status == 200 && rs.data.status) {
        exist = rs.data.data.status
      }
    } catch(error) {
      console.error(error)
    }
    return exist
  },
  async updateWatchlist({ commit, dispatch }, { subjectType, action, payload }) {
    let updateResult = false
    try {
      const rs = await apiUpdateWatchlist(subjectType, action, payload);
      if (rs && (rs.status == 200 || rs.status == 204)) {
        updateResult = rs.data.status
        await dispatch('watchlist/findWatchlist', subjectType, { root: true })
      }
    } catch (error) {
      console.error(error)
    } 
    return updateResult
  },
  async adjustWatchlist({ commit, state, dispatch }, { subjectType, subjectIDs, itemChanged }) {
    let payload = {
      subject_id: subjectIDs,
    }

    switch (subjectType) {
      case 'fund':
        payload.get_latest_at = new Date(state.fundWatchlist.updatedAt)/1000
        break
      case 'stock':
        payload.get_latest_at = new Date(state.stockWatchlist.updatedAt)/1000
        break
      case 'gold':
        payload.get_latest_at = new Date(state.goldWatchlist.updatedAt)/1000
        break
      default:
        break
    }

    let sortStatus = false
    try {
      state.loadingWatchlist = true
      const rs = await apiUpdateWatchlist(subjectType, 'sort', payload);

      if (rs && (rs.status == 200)) {
        sortStatus = rs.data.status
      }
    } catch (error) {
      console.error(error)
    } finally {
      await dispatch('watchlist/findWatchlist', subjectType, { root: true })
      state.loadingWatchlist = false
    }

    return sortStatus
  }
}